import React from 'react';

// React Bootstrap
import { Container, Col, Row, Button, Modal } from 'react-bootstrap';

// Packages
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const ConfirmDialog = (props) => {
	const { show, title, msg, onHide, confirmFunction } = props;

	const { t } = useTranslation();

	const imgStyles = {
		height: '25vh',
		display: 'block',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginBottom: '1rem'
	};
	
	return (
		<Modal
			show={show}
			onHide={onHide}
			backdrop='static'
			keyboard={false}
			size='lg'
			aria-labelledby='contained-modal-title-vcenter'
			centered
		>
			<Modal.Body>
				<img src={process.env.PUBLIC_URL + '/assets/question.png'} style={imgStyles} alt='Question' />

				<Container className='text-center mb-3'>
					<Modal.Title as='h2'>{title}</Modal.Title>
					<p className='py-3'>{msg}</p>

					<Row>
						<Col className='d-flex justify-content-evenly'>
							<Button variant='outline-secondary' onClick={onHide}>{t('ticketModal.cancel')}</Button>
							<Button className='btn simple-btn' onClick={() => { confirmFunction(); onHide(); }}>{t('confirmDialog.confirmBtn')}</Button>
						</Col>
					</Row>
				</Container>
			</Modal.Body>
		</Modal>
	);
}

ConfirmDialog.propTypes = {
	show: PropTypes.bool.isRequired,
	title: PropTypes.string.isRequired,
	msg: PropTypes.string.isRequired,
	onHide: PropTypes.func.isRequired,
	confirmFunction: PropTypes.any
}

export default ConfirmDialog;
